import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';

const PageUnauthorized = () => {
  const history = useHistory();
  return (
    <div
      style={{
        width: '100vw',
        boxSizing: 'border-box',
        margin: '0 auto',
        minHeight: '80vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <LockIcon style={{ fontSize: '5.25rem', color: '#000' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <h2>Access to this page is restricted.</h2>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <h4>You do not have permission to access the requested page.</h4>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
        <Button variant='contained' color='primary' onClick={() => history.push('/')}>
          Home
        </Button>
      </div>
    </div>
  );
};

export default PageUnauthorized;
